import { render } from "./StudentGradeEventComponent.vue?vue&type=template&id=1aa679fa&scoped=true&ts=true"
import script from "./StudentGradeEventComponent.vue?vue&type=script&lang=ts"
export * from "./StudentGradeEventComponent.vue?vue&type=script&lang=ts"

import "./StudentGradeEventComponent.vue?vue&type=style&index=0&id=1aa679fa&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa679fa"]])

export default __exports__